import { createFileRoute, redirect } from '@tanstack/react-router';

import { getUserPermissions } from '@/lib/auth/permissions';

export const Route = createFileRoute('/(authenticated)/patients/$patientId/physician-summary')({
  beforeLoad: async ({ params }) => {
    const { featureFlags } = await getUserPermissions();
    if (!featureFlags.physicianSummary) {
      throw redirect({
        to: '/patients/$patientId',
        params: { patientId: params.patientId },
        replace: true,
      });
    }
  },
});
